export default "__VITE_ASSET__Cy$8Bktd__"